"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginButton = LoginButton;
var _react = _interopRequireDefault(require("react"));
var _auth0React = require("@auth0/auth0-react");
var _lib = require("./lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function LoginButton() {
  const {
    loginWithRedirect,
    ...rest
  } = (0, _auth0React.useAuth0)();
  return /*#__PURE__*/_react.default.createElement(_lib.Button, {
    onClick: () => loginWithRedirect({
      appState: {
        returnTo: '/profile'
      }
    })
  }, "Login");
}